// eslint-disable-next-line
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Menu } from "../../assets/images/layout/menu.svg";
import { ReactComponent as Arrows } from "../../assets/images/menu/Arrows.svg";
import { ReactComponent as Category } from "../../assets/images/menu/Category.svg";
import { ReactComponent as Close } from "../../assets/images/menu/Close.svg";
import { ReactComponent as FAQ } from "../../assets/images/menu/FAQ.svg";
import { ReactComponent as Home } from "../../assets/images/menu/Home.svg";
import { ReactComponent as Language } from "../../assets/images/menu/Language.svg";
import { ReactComponent as Terms } from "../../assets/images/menu/Terms.svg";
import { ReactComponent as Unsubscribe } from "../../assets/images/menu/Unsubscribe.svg";
import { setCheckLang } from "../../redux/slice/guardSlice";
import { persistor } from '../../redux/store';
import "../../scss/pages/menu.css";

const Header = () => {
  const [menu, setMenu] = useState(false);
  const [subMenu, setSubMenu] = useState(false);
  const [lang, setLang] = useState(false);
  const { t, i18n } = useTranslation();
  const msisdn = useSelector((state) => state?.guard?.msisdn);
  const dispatch = useDispatch();
  let navigate = useNavigate();


  const menuHandler = () => {
    setMenu(false);
  };

  // Restore language + RTL on mount
  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || "en";
    i18n.changeLanguage(savedLang);
    dispatch(setCheckLang(savedLang));
    applyRTL(savedLang);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menu ? "hidden" : "auto";
    return () => { document.body.style.overflow = "auto"; };
  }, [menu]);

  const applyRTL = (lng) => {
    if (lng === "ar") {
      document.documentElement.dir = "rtl";
      document.body.classList.add("rtl");
    } else {
      document.documentElement.dir = "ltr";
      document.body.classList.remove("rtl");
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng, (err) => {
      if (err) return console.log("something went wrong loading", err);
      localStorage.setItem("lang", lng);
      applyRTL(lng);
    });
    dispatch(setCheckLang(lng));
    setLang(false);
    setMenu(false);
  };

  const logOutHandler = async () => {
    try {
      const response = await axios.get(
         `https://wbilzss.tickhighs.com/sub/unsub?msisdn=${msisdn}&serviceId=WELLNESS`
      );
      localStorage.clear();
      persistor.purge();
      navigate("/");
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      localStorage.clear();
    }
  };

  return (
    <header>
      <div className="logoText">
        <h2>{t("menu.mt_wellness")}</h2>
        <Menu onClick={() => setMenu(true)} />
      </div>

      {/* Overlay */}
      <div
        className={menu ? "menu-overlay active" : "menu-overlay"}
        onClick={() => setMenu(false)}
      ></div>

      <div className={menu ? "menuWrapper active" : "menuWrapper"}>
        <div className="menuTitlte">
          <div className="cont">
            <h2>{t("menu.welcome")}</h2>
            <p>{t("menu.mt_wellness")}</p>
          </div>
          <div className="close">
            <Close onClick={() => setMenu(false)} />
          </div>
        </div>

        <div className="menuList">
          <ul>
            {/* Home */}
            <li>
              <Link to="/home" onClick={menuHandler}>
                <span><Home /></span>
                {t("menu.home")}
              </Link>
            </li>

            {/* Category */}
            <li onClick={() => setSubMenu(!subMenu)}>
              <span className="submenuWrap">
                <Link to="#">
                  <span><Category /></span>
                  {t("menu.category")}
                </Link>
                <Arrows className={subMenu ? "rotated" : ""} />
              </span>
              {subMenu && (
                <div className="sunmenu">
                  <ul>
                    <li><Link to="/exercise" onClick={menuHandler}>{t("submenu.exercise")}</Link></li>
                    <li><Link to="/meditation" onClick={menuHandler}>{t("submenu.meditation")}</Link></li>
                    <li><Link to="/yoga" onClick={menuHandler}>{t("submenu.yoga")}</Link></li>
                    <li><Link to="/zumba" onClick={menuHandler}>{t("submenu.zumba")}</Link></li>
                  </ul>
                </div>
              )}
            </li>

            {/* Language */}
            <li onClick={() => setLang(!lang)}>
              <span className="submenuWrap">
                <Link to="#">
                  <span><Language /></span>
                  {t("menu.language")}
                </Link>
                <Arrows className={lang ? "rotated" : ""} />
              </span>
              {lang && (
                <div className="sunmenu">
                  <ul>
                    <li>
                      <Link to="#" onClick={() => changeLanguage("en")}>
                        {t("languages.english")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => changeLanguage("ar")}>
                        {t("languages.arabic")}
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* FAQ */}
            <li>
              <Link to="/faq">
                <span><FAQ /></span>
                {t("menu.faqs")}
              </Link>
            </li>

            {/* Terms */}
            <li>
              <Link to="/terms-conditions">
                <span><Terms /></span>
                {t("menu.terms_conditions")}
              </Link>
            </li>

            {/* Unsubscribe */}
            <li>
              <Link to="#" onClick={logOutHandler}>
                <span><Unsubscribe /></span>
                {t("menu.unsubscribe")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
